import React, { useEffect, useContext, useState } from 'react';
import $ from 'jquery';
import DataTable from 'datatables.net';
import { LoginContext } from '../../hooks/context/LoginContext';
import axios from 'axios';
import Menusup from '../../componentes/menus/menusup/Menusup';
import Sidebar from '../../componentes/menus/sidebar/Sidebar';
import Footer from '../../componentes/footer/Footer';
import Section from '../../componentes/ui/Section';
import MiDataTableLineas from './MiDataTableLineas';
import MiDataTableSolicitudes from './MiDataTableSolicitudes';
import PermissionRefused from '../../componentes/ui/PermissionRefused';
import LoadingPage from '../../componentes/ui/LoadingPage';
import Kpi from '../../componentes/ui/Kpi';
import Button from '../../componentes/ui/Button';
import ButtonOutline from '../../componentes/ui/ButtonOutline';
import MiSelect from '../../componentes/formulario/MiSelect';
import MiSelectMultiple from '../../componentes/formulario/MiSelectMultiple';
import TextArea from '../../componentes/formulario/TextArea';
import FormInput from '../../componentes/formulario/FormInput';
import { Spinner } from 'react-bootstrap';
import swal from 'sweetalert';
import { Modal } from 'react-bootstrap';
import { Fragment } from 'react';
import FormRow from '../../componentes/formulario/FormRow';
import { NavLink } from 'react-router-dom';
import MiDataTableRequest from './MiDataTableRequest';
import { alertService } from '../../services/alertservice';
import { Alert } from '../../componentes/ui/Alert';
import useLogicForm from '../../hooks/useLogicForm';
import Cookies from 'universal-cookie';
import { getApiUrl, axiosPost, MiReplaceAll, getAhoraddmmyyyy, getPantDocFromNivel, setStockOptionsSelectUbi, getStockOptionsSelectUbi, getTitle, encryptData, getDecodedCookie } from '../../helpers/helperApp';


$.DataTable = DataTable;
const url = window.location;

function Request(props){

    const cookies = new Cookies();
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    // ***** Context *****
    const { validateSesion, socket, confApp, saveConfApp, getConfApp, apiKey, appCryptCom } = useContext(LoginContext);    

    // ***** State para la configuración de la pantalla *****
    const [ confPantalla, saveConfPantalla ] = useState(confApp)
    const [ loadedConf, saveLoadedConf ] = useState(false);
    const [ tieneNivel, saveTieneNivel ] = useState(true);
    const [ lineas, saveLineas ] = useState([])    
    const [ infoDoc, saveInfoDoc ] = useState(null);
    const [ clones, saveClones ] = useState([]);
    const [ loadingTable, saveLoadingTable ] = useState(false);
    const [ loadingTable2, saveLoadingTable2 ] = useState(false);
    const [ solicitando, saveSolicitando ] = useState(false);
    const [ showModalSolicitar, saveShowModalSolicitar ] = useState(false);
    const [ valResponsable, saveValResponsable ] = useState([]);
    const [ valNotas, saveValNotas ] = useState("");
    const [ valFec2, saveValFec2 ] = useState("");
    const [ valLineas, saveValLineas ] = useState([]);
    const [ showModalEditarLineas, saveShowModalEditarLineas ] = useState(false);
    const [ lineasModalEditar, saveLineasModalEditar ] = useState([]);
    const [ articulosEnDocumento, saveArticulosEnDocumento ] = useState([]);

    // ***** Custom Hook - Lógica de los formularios *****
    // const {  loadingTable, saveLoadingTable, loadReg } = useLogicForm();

    useEffect( () => {        
        
        // ***** Validamos que el usuario esté logueado sino lo enviamos al login*****
        validateSesion(props)
            .then( (respuesta) => {
                if( confPantalla === undefined ){
                    return getConfApp();
                }else{ 
                    document.title = getTitle(confPantalla.config.trad, confPantalla.request.title);                    
                    if( respuesta == 1 ){
                        saveTieneNivel(true);
                        // Seleccionar los parámetros que nos llegan por la url
                        if( props.location.state ){
                            if( "iddoc" in props.location.state ){                               
                                loadInfoDoc(props.location.state.iddoc); 
                                loadLineas(props.location.state.iddoc);
                                loadClones(props.location.state.iddoc);   
                            }                               
                        }                        
                    }
                    else if( respuesta == 0 ){
                        saveTieneNivel(false);
                    }                    
                    saveLoadedConf(true);        
                }
            })
            .then( (respuesta) => {
                if( respuesta !== undefined  ){
                    saveConfPantalla(respuesta.msg);
                    saveConfApp(respuesta.msg);             
                }
            })          

        // Liberamos todos los registros al salir de la pantalla
        return () =>{
            if( socket != null ){
                socket.emit("salirPantalla", { "idusu": getDecodedCookie('id'), "tabla": "undefined" })
            }
                document.querySelector("body").classList.remove("sidebar-open");

                // Token cancelación axios al desmontar componentes
                source.cancel();
        } 

    },[confPantalla])


    const loadInfoDoc = async(idDoc) => {
        const data = new FormData();      
        data.append("validacion", apiKey());
        data.append("iddoc", idDoc);
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.request.controles.loadinfodoc, data, source.token);        
        if( typeof respuesta.data == "string"){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});         
        }else{
            saveInfoDoc(respuesta.data[0]);
        }
    }

    const loadLineas = async(idDoc) => {
        saveLoadingTable(true);
        const data = new FormData();      
        data.append("validacion", apiKey());
        data.append("iddoc", idDoc);
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.request.controles.datatable.getdata, data, source.token);        
        if( typeof respuesta.data == "string"){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});         
        }else{
            saveLineas(respuesta.data);
        }
        saveLoadingTable(false);
    }

    const loadClones = async(idDoc) => {
        saveLoadingTable2(true);
        const data = new FormData();      
        data.append("validacion", apiKey());
        data.append("iddoc", idDoc);
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.request.controles.datatableclones.getdata, data, source.token);        
        if( typeof respuesta.data == "string"){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});         
        }else{
            saveClones(respuesta.data);
        }
        saveLoadingTable2(false);
    }

    const btnSolicitar = () => {
        let table = $("#tab1").DataTable();
        const rows = table.rows( { selected: true } ).data();
        if( rows.length > 0 ){
            saveValResponsable([]);
            saveValNotas(rows[0].defaultnotas);
            saveValFec2("");
            saveValLineas(rows);
            saveShowModalSolicitar(true);
        }else{
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${confPantalla.request.controles.emptyclick.title}`,{autoClose: true});                    
        }
    }    

    const accionSolicitar = async() => {
        let table = $("#tab1").DataTable();
        // const rows = table.rows( { selected: true } ).data();
        let tableLineas = $('#tabmodallineas').DataTable();
        const rowsLineas = tableLineas.rows().data();
        if( rowsLineas.length > 0 ){
            saveSolicitando(true);
            
            const lineas = [];
            rowsLineas.map(row => {
                delete row.style;
                lineas.push(row);
            })
            
            const data = new FormData();      
            data.append("validacion", apiKey());
            data.append("iddoc", infoDoc.id);            
            data.append("dest", valResponsable.join(','));
            data.append("notas", valNotas);
            data.append("fec2", valFec2);
            data.append("lineas", JSON.stringify(lineas));            
            const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.request.controles.solicitar, data, source.token);        
            if( typeof respuesta.data == "string"){
                alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});         
            }else{
                alertService.success(`<i class="fal fa-check-circle mr-1"></i>${confPantalla.request.controles.solicitadook.title}`, {autoClose: true});
                table.rows().deselect();
                saveArticulosEnDocumento([]);
                await loadLineas(infoDoc.id);
                await loadClones(infoDoc.id);                
            }  
        }else{
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${confPantalla.request.controles.emptyclick.title}`,{autoClose: true});                    
        }
        saveSolicitando(false);
        saveShowModalSolicitar(false);
    }

    const editarLineas = async (rowData) => {        
        saveLoadingTable2(true);
        const data = new FormData();      
        data.append("validacion", apiKey());
        data.append("iddoc", rowData.id);
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.request.controles.modaleditarlineas.datatablelineas.getdata, data, source.token);
        if( typeof respuesta.data == "string"){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});         
        }else{            
            saveLineasModalEditar(respuesta.data);
            saveShowModalEditarLineas(true);
        }
        saveLoadingTable2(false);                
    }

    const accionEditarLineas = async () => {
        
        saveSolicitando(true);

        const data = new FormData();      
        data.append("validacion", apiKey());
        data.append("lineas", JSON.stringify(lineasModalEditar));            
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.request.controles.modaleditarlineas.updatelineasmodaleditar, data, source.token);        
        if( typeof respuesta.data == "string"){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});         
        }else{
            alertService.success(`<i class="fal fa-check-circle mr-1"></i>${confPantalla.request.controles.modaleditarlineas.editadook.title}`, {autoClose: true});
        }  
        saveSolicitando(false);
        saveShowModalEditarLineas(false);
    }

    const selectArticulos = (idRow, id, datos, selectedRows) => {        
        if(selectedRows.length > 0){            
            saveArticulosEnDocumento(selectedRows[0].idsuni.split(","));
        }else{
            saveArticulosEnDocumento([]);
        }

    }

    const handleSelectMultiple = (selectedItem, nameOfComponent, saveData) => {
        let optionsSeleccionadas = [];        
        
        for(let i = 0; i < selectedItem.length; i++){
            optionsSeleccionadas.push(selectedItem[i].value);
        }
        
        if( selectedItem ){
            saveData(optionsSeleccionadas);
        }else{            
            saveData([]);
        }
    }

    const handleInput = (e, saveData) => {        
        const { name, value } = e.target;
        saveData(value)       
    }

    
    return(
        <div className="App wrapper">   
        {
            confPantalla !== undefined
            ?
                <Fragment>
                    <Alert fondo={true} />
                    <Menusup 
                        props = { props }
                    />
                    <Sidebar 
                        props = { props }
                    />
                </Fragment>
            :
            null
        } 
        <div className="content-wrapper">
            <div className="content-header">
            </div>
            <section className="content">                
                {
                    !tieneNivel 
                    ?
                        <PermissionRefused
                            traduction={confPantalla.config.trad.components.permissionrefused} 
                        />
                    :
                    <Fragment>
                    {
                        loadedConf === true && confPantalla !== undefined
                        ?
                            <Section
                                titulo={ 
                                    infoDoc == null
                                    ?
                                        confPantalla.request.section.titulo
                                    :
                                        getDecodedCookie('idioma').toLowerCase() == "es".toLowerCase() ?
                                            infoDoc.tipdocnom+" - "+infoDoc.nom1
                                        :
                                            getDecodedCookie('idioma').toLowerCase() == "en".toLowerCase() ?
                                                infoDoc.tipdocnom+" - "+infoDoc.nom1_en
                                            :
                                                infoDoc.tipdocnom+" - "+infoDoc.nom1+" - "+infoDoc.nom1_en
                                }  
                                icono={ confPantalla.request.section.icono } 
                                col={ confPantalla.request.section.col } 
                                idPrin={ infoDoc ? infoDoc.id : ''  } 
                                borderHeader={ infoDoc != null ? infoDoc.color : null }                                
                            >
                                {   loadingTable == true ?
                                        <div className='mt-4' style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                            <Spinner animation="border" />
                                        </div>
                                    :
                                        null
                                }
                                <MiDataTableSolicitudes 
                                    estadoForm= { "" }
                                    formulario={ {id:0} }
                                    id={"tab1"}
                                    columnas={confPantalla.request.controles.datatable.columns}
                                    data={lineas}
                                    buttons={confPantalla.request.controles.datatable.buttons}
                                    ordering={confPantalla.request.controles.datatable.ordering}
                                    order={confPantalla.request.controles.datatable.order}
                                    searching={confPantalla.request.controles.datatable.searching}
                                    paging={confPantalla.request.controles.datatable.paging}
                                    select={confPantalla.request.controles.datatable.select}
                                    pagelength={confPantalla.request.controles.datatable.pagelength}
                                    // saveLoadingTable={ saveLoadingTable }
                                    // loadingTable={loadingTable}
                                    columnactions={confPantalla.request.controles.datatable.columnactions.title}
                                    linkColumns={confPantalla.request.controles.datatable.linkColumns}
                                    traduction={confPantalla.config.trad.components.datatable}
                                    selectIds={articulosEnDocumento}
                                    selectIdsKeySearch={"iduni"}
                                />
                                <div className='row'>
                                    <div className='col-12 col-md-6 pl-1 pr-1'>
                                        {
                                            infoDoc != null
                                            ?
                                                <button 
                                                    type="button" 
                                                    onClick={ () => btnSolicitar(true) } 
                                                    className="btn btn-flat btn-success col-12 mt-2 mb-4 pr-1" 
                                                    disabled={ solicitando ? true : false } 
                                                >
                                                    {confPantalla.request.controles.btnsolicitar.title}
                                                    {
                                                        solicitando
                                                        ? 
                                                            <Spinner as="span" style={{marginLeft: "10px"}} animation="border" size="sm" />
                                                        :
                                                            null
                                                    }
                                                </button>
                                            :
                                                null
                                        }
                                    </div>
                                    <div className='col-12 col-md-6 pl-1 pr-1'>
                                        {
                                            infoDoc != null
                                            ?
                                                <NavLink className='btn btn-flat btn-primary col-12 mt-2 mb-4' to={"/response/"+infoDoc.id}>
                                                    <i className='fal fa-reply mr-1'></i>
                                                    {confPantalla.request.controles.btngotoresponse.title}
                                                </NavLink>
                                            :
                                                null
                                        }
                                    </div>
                                </div>
                                {   loadingTable2 == true ?
                                        <div className='mt-4' style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                            <Spinner animation="border" />
                                        </div>
                                    :
                                        null
                                }                                 
                                <MiDataTableRequest
                                    id={"tab2"}
                                    columnas={confPantalla.request.controles.datatableclones.columns}
                                    data={clones}
                                    buttons={confPantalla.request.controles.datatableclones.buttons}
                                    ordering={confPantalla.request.controles.datatableclones.ordering}
                                    order={confPantalla.request.controles.datatableclones.order}
                                    searching={confPantalla.request.controles.datatableclones.searching}
                                    paging={confPantalla.request.controles.datatableclones.paging}
                                    select={confPantalla.request.controles.datatableclones.select}
                                    pagelength={confPantalla.request.controles.datatableclones.pagelength}
                                    // saveLoadingTable={ saveLoadingTable2 }
                                    // loadingTable={loadingTable2}
                                    columnactions={confPantalla.request.controles.datatableclones.columnactions.title}
                                    traduction={confPantalla.config.trad.components.datatable}                                                                        
                                    confPantalla={confPantalla}
                                    editarLineas={editarLineas}
                                    functionAfterSelect={selectArticulos}
                                />                                
                            </Section>
                        :
                            <LoadingPage />
                        }
                    </Fragment>
                }
                {
                showModalSolicitar
                ?
                    <Modal
                        show={showModalSolicitar}
                        onHide={ () => saveShowModalSolicitar(false)}                            
                        aria-labelledby="example-custom-modal-styling-title"
                        centered={true}                    
                        dialogClassName="modal-90w "
                        backdrop="static" 
                        backdropClassName='requestmodalrespbackdrop'                                       
                    >
                        <Modal.Header closeButton>
                            <h4>{confPantalla.request.controles.modalsolicitar.header.title}</h4>
                        </Modal.Header>                                              
                        <Modal.Body>
                            <FormRow>
                                <MiSelectMultiple  
                                    estadoForm=  { "" }
                                    val=         { valResponsable }   
                                    loading=     { false }
                                    id=          { confPantalla.request.controles.modalsolicitar.idage2.id }    
                                    name=        { confPantalla.request.controles.modalsolicitar.idage2.name }   
                                    label=       { confPantalla.request.controles.modalsolicitar.idage2.label }    
                                    placeholder= { confPantalla.request.controles.modalsolicitar.idage2.placeholder }
                                    col=         { confPantalla.request.controles.modalsolicitar.idage2.col } 
                                    isClearable= { confPantalla.request.controles.modalsolicitar.idage2.isclearable }
                                    isSearchable={ confPantalla.request.controles.modalsolicitar.idage2.issearchable }
                                    dataType=    { confPantalla.request.controles.modalsolicitar.idage2.datatype }
                                    data=        { confPantalla.request.controles.modalsolicitar.idage2.data }
                                    required=    { confPantalla.request.controles.modalsolicitar.idage2.required } 
                                    disabled=  { confPantalla.request.controles.modalsolicitar.idage2.disabled }
                                    readOnly =   { confPantalla.request.controles.modalsolicitar.idage2.readonly }
                                    disablethisid={confPantalla.request.controles.modalsolicitar.idage2.disablethisid}
                                    disableids={ confPantalla.request.controles.modalsolicitar.idage2.disableids}
                                    formulario= { {id:0} }   
                                    change= { (selectedItem, nameOfComponent) => handleSelectMultiple(selectedItem, nameOfComponent, saveValResponsable) }
                                />
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { valFec2 }
                                    loading=    { false }
                                    id=         { confPantalla.request.controles.modalsolicitar.fec2.id }   
                                    type=       { confPantalla.request.controles.modalsolicitar.fec2.type }  
                                    name=       { confPantalla.request.controles.modalsolicitar.fec2.name }   
                                    label=      { confPantalla.request.controles.modalsolicitar.fec2.label }                                                       
                                    placeholder={ confPantalla.request.controles.modalsolicitar.fec2.placeholder }    
                                    col=        { confPantalla.request.controles.modalsolicitar.fec2.col } 
                                    required=   { confPantalla.request.controles.modalsolicitar.fec2.required }
                                    readonly=   { confPantalla.request.controles.modalsolicitar.fec2.readonly }                                                
                                    disabled=   { confPantalla.request.controles.modalsolicitar.fec2.disabled }
                                    change=     { e => handleInput(e, saveValFec2) }
                                    onBlur=     {null} 
                                />
                            </FormRow>
                            <FormRow>
                                <TextArea                                                        
                                    estadoForm= { '' }
                                    // value=      { MiReplaceAll(valNotas, '<br>', '') }
                                    value=      { valNotas }
                                    loading=    { false }
                                    id=         { confPantalla.request.controles.modalsolicitar.notasadd.id }   
                                    name=       { confPantalla.request.controles.modalsolicitar.notasadd.name }
                                    rows=       { confPantalla.request.controles.modalsolicitar.notasadd.rows }      
                                    label=      { confPantalla.request.controles.modalsolicitar.notasadd.label }                                                       
                                    placeholder={ confPantalla.request.controles.modalsolicitar.notasadd.placeholder }    
                                    col=        { confPantalla.request.controles.modalsolicitar.notasadd.col } 
                                    required=   { confPantalla.request.controles.modalsolicitar.notasadd.required }
                                    readonly=   { confPantalla.request.controles.modalsolicitar.notasadd.readonly }                                                
                                    disabled=   { confPantalla.request.controles.modalsolicitar.notasadd.disabled }
                                    change=     { e => handleInput(e, saveValNotas) }
                                    onBlur=     {null} 
                                />
                            </FormRow>
                            
                            <p className="font-italic text-center">{confPantalla.request.controles.modalsolicitar.required.title}</p>                             
                            <MiDataTableLineas 
                                estadoForm= { "" }
                                formulario={ {id:0} }
                                id={"tabmodallineas"}
                                columnas={confPantalla.request.controles.modalsolicitar.datatablelineas.columns}
                                data={valLineas}
                                saveData={saveValLineas}
                                buttons={confPantalla.request.controles.modalsolicitar.datatablelineas.buttons}
                                ordering={confPantalla.request.controles.modalsolicitar.datatablelineas.ordering}
                                order={confPantalla.request.controles.modalsolicitar.datatablelineas.order}
                                searching={confPantalla.request.controles.modalsolicitar.datatablelineas.searching}
                                paging={confPantalla.request.controles.modalsolicitar.datatablelineas.paging}
                                select={confPantalla.request.controles.modalsolicitar.datatablelineas.select}
                                pagelength={confPantalla.request.controles.modalsolicitar.datatablelineas.pagelength}                                    
                                columnactions={confPantalla.request.controles.modalsolicitar.datatablelineas.columnactions.title}
                                linkColumns={confPantalla.request.controles.modalsolicitar.datatablelineas.linkColumns}
                                traduction={confPantalla.config.trad.components.datatable}                                
                            />                            
                            {  solicitando ? 
                                    <div className='mt-4' style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                        <Spinner animation="border" />
                                    </div>
                                :
                                null
                            }                                                
                        </Modal.Body>
                        <Modal.Footer>
                            <div className='text-right'>
                                <button 
                                        className="btn btn-success mt-1 mr-1"
                                        onClick={ () => accionSolicitar() }
                                        disabled={valResponsable == [] || valNotas == "" || valFec2 == "" || solicitando ? true : false}                                        
                                >
                                    {confPantalla.request.controles.modalsolicitar.btnaceptar.title}
                                </button>
                                <button 
                                    className="btn btn-danger mt-1"
                                    onClick={ () => saveShowModalSolicitar(false) }                                        
                                >
                                    {confPantalla.request.controles.modalsolicitar.btncancelar.title}
                                </button>                             
                            </div>
                        </Modal.Footer>                            
                    </Modal>
                :
                    null
                }
                {
                showModalEditarLineas
                ?
                    <Modal
                        show={showModalEditarLineas}
                        onHide={ () => saveShowModalEditarLineas(false)}                            
                        aria-labelledby="example-custom-modal-styling-title"
                        centered={true}                    
                        dialogClassName="modal-90w "
                        backdrop="static" 
                        backdropClassName='requestmodalrespbackdrop'                                       
                    >
                        <Modal.Header closeButton>
                            <h4>{confPantalla.request.controles.modaleditarlineas.header.title}</h4>
                        </Modal.Header>                                              
                        <Modal.Body>                                                                                
                            <MiDataTableLineas 
                                estadoForm= { "" }
                                formulario={ {id:0} }
                                id={"tabmodallineaseditar"}
                                columnas={confPantalla.request.controles.modaleditarlineas.datatablelineas.columns}
                                data={lineasModalEditar}
                                saveData={saveLineasModalEditar}
                                buttons={confPantalla.request.controles.modaleditarlineas.datatablelineas.buttons}
                                ordering={confPantalla.request.controles.modaleditarlineas.datatablelineas.ordering}
                                order={confPantalla.request.controles.modaleditarlineas.datatablelineas.order}
                                searching={confPantalla.request.controles.modaleditarlineas.datatablelineas.searching}
                                paging={confPantalla.request.controles.modaleditarlineas.datatablelineas.paging}
                                select={confPantalla.request.controles.modaleditarlineas.datatablelineas.select}
                                pagelength={confPantalla.request.controles.modaleditarlineas.datatablelineas.pagelength}                                    
                                columnactions={confPantalla.request.controles.modaleditarlineas.datatablelineas.columnactions.title}
                                linkColumns={confPantalla.request.controles.modaleditarlineas.datatablelineas.linkColumns}
                                traduction={confPantalla.config.trad.components.datatable}
                                modallineaseditar={true}
                                importexcel={true}
                            />                            
                            {  solicitando ? 
                                    <div className='mt-4' style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                        <Spinner animation="border" />
                                    </div>
                                :
                                null
                            }                                                
                        </Modal.Body>
                        <Modal.Footer>
                            <div className='text-right'>
                                <button 
                                        className="btn btn-success mt-1 mr-1"
                                        onClick={ () => accionEditarLineas() }
                                        disabled={solicitando ? true : false}                                        
                                >
                                    {confPantalla.request.controles.modaleditarlineas.btnaceptar.title}
                                </button>
                                <button 
                                    className="btn btn-danger mt-1"
                                    onClick={ () => saveShowModalEditarLineas(false) }
                                >
                                    {confPantalla.request.controles.modaleditarlineas.btncancelar.title}
                                </button>                             
                            </div>
                        </Modal.Footer>                            
                    </Modal>
                :
                    null
                }                    
            </section>
        </div>
        <Footer />        
        </div>

    );

}
export default Request